/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { createSlug, generateUniqueId, getErrorDetailsFn, getInputFieldProps, safeToString, } from "../../../utils/common";
import { ALLOWANCE_API, ALLOWANCE_INITIAL_STATE, ALLOWANCE_INPUT_FIELDS } from "./allowance-constant";
import { allowanceSchema } from "./allowance-validation";
import useSnackbar from "../../../hook/use-snakbar";
import { useNavigate } from "react-router-dom";
import { logger, safeString } from "../../../utils/logger";



const useAllowanceService = () => {
  const [allowanceListResponse, setAllowanceListResponse] = useState([]);
  const [allowanceListFetching, setAllowanceListFetching] = useState(false);
  const [allowancedialogOpen, setAllowancedialogOpen] = useState(false);
  const [addAnotherAllowance, setaddAnotherAllowance] = useState(false);

  
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();


  const [allowance, setAllowance] = useState(ALLOWANCE_INITIAL_STATE);
  const { fetchData } = useAPIHandler();


  const [errors, setErrors] = useState({});

  const handleChangeFunction = (e, name) => {



    let value = e;



    if (e && e.target) {
      value = e.target.value;
    }



    if (ALLOWANCE_INPUT_FIELDS[name].customOptions && ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn) {
      value = ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn(value, allowance);

    }

    setAllowance((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = allowanceSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: { allowanceType: allowance.allowanceType },

    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  };
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);



  const onSubmitHandler = async (e) => {
    e?.preventDefault();




    const {
      allowanceName,

      allowanceType
      , allowanceValue,
      noWorkNoPay,
      isEsiWages,
      isEpfWages,

    } = allowance;


  const trimmedallowanceName=  allowanceName?.trim();
    const { error } = allowanceSchema.validate({
      allowanceName:trimmedallowanceName,

      allowanceType
      , allowanceValue,
      noWorkNoPay,
      isEsiWages,
      isEpfWages,
    }, {
      abortEarly: false,
      context: { allowanceType },
    });


    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);

    } else {


      if (allowance?.customId) {

        const filterOtherAllowance=allowanceListResponse.filter(it=>it?.customId !== allowance?.customId);

        if(filterOtherAllowance.length>0){



          const duplicateAllowance = filterOtherAllowance.find(
            (it) =>
              safeString(it?.allowanceName).toLowerCase().trim() ===
              safeString(trimmedallowanceName).toLowerCase().trim()
          );
logger.log({duplicateAllowance,filterOtherAllowance},"duplicateAllowance,filterOtherAllowance")
        if(duplicateAllowance.allowanceName){
     
          openSnackbar({
            message:"Allowance Name Already exits!",
      color: "danger",
      });
          return;
        }
      }


        setAllowanceListResponse(prev => (prev.map(it => it?.customId === allowance?.customId ? {
          ...allowance,

          slug: createSlug(trimmedallowanceName)
        } : it)))
      } else {


        if(allowanceListResponse.length>0){

    

          const duplicateAllowance = allowanceListResponse.find(
            (it) =>
              safeString(it?.allowanceName).toLowerCase().trim() ===
              safeString(trimmedallowanceName).toLowerCase().trim()
          );
          if(duplicateAllowance?.allowanceName){
        
            openSnackbar({
              message:"Allowance Name Already exits!",
        color: "danger",
        });
            return;
          }
        }
        setAllowanceListResponse(prev => ([...prev,



        {
          customId: generateUniqueId(),

          allowanceName:trimmedallowanceName,
          status: true,
          allowanceType
          , allowanceValue,
          noWorkNoPay,
          isEsiWages,
          isEpfWages,
          slug: createSlug(trimmedallowanceName)
        }

        ]))
      }



      if (!addAnotherAllowance) {
        setAllowancedialogOpen(false);
      } else {
        setAllowance(ALLOWANCE_INITIAL_STATE);
      }

    }


  };





  const onSubmitApi = async () => {
    setCreateUpdateLoading(true);



    const URL = ALLOWANCE_API.ALLOWANCE_CREATE.URL;
    const METHOD = ALLOWANCE_API.ALLOWANCE_CREATE.METHOD;

    try {
    const res=  await fetchData({
        data: allowanceListResponse?.map(({customId,...it})=>it),
        url: URL,
        method: METHOD,
      });
     

      openSnackbar({
        message:"Allowance Updated succesfully!",
color: "success",
});

    } catch (error) {
    setCreateUpdateLoading(false);
    const {

      type,
      message,
      details,
      errorObj
    }=    getErrorDetailsFn(error)
    openSnackbar({
      message,
color: "danger",
});
      
    }finally{
    setCreateUpdateLoading(false);

    }
  


  }
  const navigate=useNavigate();

  async function getAllowanceListFn() {
    setAllowanceListFetching(true);
    const allAllowances = {
        masterAllowance: [],
        organizationAllowance: [],
    };

    try {
        // Fetch master allowances
        const masterData = await fetchData({ url: ALLOWANCE_API.MASTER_ALLOWANCE_LIST.URL });
        const masterAllowances =
            (await masterData?.data?.map(it => ({
                ...ALLOWANCE_INITIAL_STATE,
                ...it,
                customId: it?.allowance_master_id,
                allowanceName: it?.allowance_master_name,
            }))) || [];

        if (masterAllowances.length > 0) {
            allAllowances.masterAllowance = masterAllowances;
        }

        // Fetch organization allowances
        const orgDtaData = await fetchData({ url: ALLOWANCE_API.ALLOWANCE_LIST.URL });
        const orgDtaAllowance =
            (await orgDtaData?.data?.allowances?.map(it => ({
                ...ALLOWANCE_INITIAL_STATE,
                ...it,
                customId: it?.allowanceId,
            }))) || [];

        if (!orgDtaAllowance.length) {

            navigate("/organization/allowance")
        }
        if (orgDtaAllowance.length > 0) {
            allAllowances.organizationAllowance = orgDtaAllowance;

          
        }

        // Update state with fetched allowances
        setAllowanceListResponse([
            ...allAllowances.masterAllowance,
            ...allAllowances.organizationAllowance,
        ]);

        // Show modal if both are empty
        if (
            allAllowances.masterAllowance.length === 0 &&
            allAllowances.organizationAllowance.length === 0
        ) {
          setAllowancedialogOpen(true);
        }
    } catch (error) {
        console.error('Error fetching allowances:', error);
    } finally {
        setAllowanceListFetching(false);
    }
}

  useEffect(() => {
  
    getAllowanceListFn()

  }, []);

  const getInputFieldPropsFn = (fieldName) => {

    const {customOptions
      ,...restProps}=ALLOWANCE_INPUT_FIELDS[fieldName];

      const error=safeToString(errors[fieldName]).replace("value", allowance.allowanceType !== 'fixed' ? "Percentage":"Amount");
    const props = { ...restProps, ...getInputFieldProps({ name: fieldName, stateValues: allowance, type: ALLOWANCE_INPUT_FIELDS[fieldName].type, error, handleChangeFunction }) };

    return props;

  }



  return {
    allowancedialogOpen, setAllowancedialogOpen,
    allowanceListFetching,
    handleChangeFunction,
    allowance,
    onSubmitHandler,
    setAllowance,
    allowanceListResponse,
    ALLOWANCE_INITIAL_STATE,
    setAllowanceListResponse,
    onSubmitApi,
    getInputFieldProps: getInputFieldPropsFn,
    addAnotherAllowance, setaddAnotherAllowance,
    createUpdateLoading,
    setErrors,
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
    
  };
};

export default useAllowanceService;
